export const LOST_SALE_RESUME_EXPORT_ID = "lost-sale-resume";

export const LOST_SALE_RESUME_TITLE = "Venta Perdida";

export const LOCALIZED_RESUME_PROPERTIES = {
  trip: "Viaje",
  numberOrder: "Pedido",
  invoiceDocument: "Factura",
  sellerToName: "Responsable",
  subRoute: "Ruta",
  salesOffice: "Oficina de Venta",
  shipToExternalKeyCode: "Código Cliente",
  shipToName: "Cliente",
  date: "Fecha",
  loadDateTime: "Fecha de Carga",
  materialCode: "Código de Material",
  materialName: "Material",
  location: "Ubicación",
  parallelUnitOfMeasure: "UMP",
  pararellConversionFactor: "Factor de Conversión",
  sumSoldQuantity: "Suma Pedido",
  sumStockConfirmedERP: "Suma Reserva",
  sumDeliveredQuantity: "Suma Desp.",
  sumInvoiceQuantity: "Suma Factura",
  baseUnitOfMeasure: "UMB",
  soldUnitOfMeasure: "UMP",
  soldQuantity: "Cnt. Pedido",
  soldQuantityParallel: "Cnt. Pedido Paralela",
  stockConfirmedERP: "Cnt. Reserva",
  stockConfirmedERPParallel: "Cnt. Reserva Paralela",
  deliveredQuantity: "Cnt. Entrega.",
  deliveredQuantityParallel: "Cnt. Entrega Paralela",
  invoiceQuantity: "Cnt. Factura",
  invoiceQuantityParallel: "Cnt. Factura Paralela",
  lostSale: "Dif",
};

export const LOST_SALE_COMMERCIAL_EXPORT_ID = "lost-sale-commercial";

export const LOST_SALE_COMMERCIAL_TITLE = "Venta Perdida Comercial";

export const LOCALIZED_COMMERCIAL_PROPERTIES = {
  trip: "Viaje",
  numberOrder: "Pedido",
  invoiceDocument: "Factura",
  sellerToName: "Responsable",
  subRoute: "Ruta",
  salesOffice: "Oficina de Venta",
  user: "Usuario",
  date: "Fecha",
  loadDateTime: "Fecha de Carga",
  shipToExternalKeyCode: "Código Socio de Negocio",
  shipToName: "Socio de Negocio",
  materialCode: "Código de Material",
  materialName: "Material",
  soldQuantitySuggestedUMP: "Cantidad Solicitada (UMP)",
  soldQuantitySuggested: "Cantidad Solicitada (UMB)",
  soldUnitOfMeasure: "UMB",
  pararellUnitOfMeasure: "UMP",
  soldQuantityUMP: "Cantidad Vendida (UMP)",
  soldQuantity: "Cantidad Vendida (UMB)",
  stockAtCreation: "Stock al Momento (UMB)",
  stockAtCreationUMP: "Stock al Momento (UMP)",
  lostSale: "Venta Perdida (UMB)",
  lostSaleUMP: "Venta Perdida (UMP)",
};

export const LOST_SALE_LOGISTIC_EXPORT_ID = "lost-sale-logistic";

export const LOST_SALE_LOGISTIC_TITLE = "Venta Perdida Logística";

export const LOCALIZED_LOGISTIC_PROPERTIES = {
  trip: "Viaje",
  numberOrder: "Pedido",
  invoiceDocument: "Factura",
  sellerToName: "Responsable",
  subRoute: "Ruta",
  salesOffice: "Oficina de Venta",
  user: "Usuario",
  date: "Fecha",
  loadDateTime: "Fecha de Carga",
  shipToExternalKeyCode: "Código Socio de Negocio",
  shipToName: "Socio de Negocio",
  deliveryDocument: "Entrega",
  materialCode: "Código de Material",
  materialName: "Material",
  baseUnitOfMeasure: "UMB",
  parallelUnitOfMeasure: "UMP",
  soldQuantitySuggested: "Cantidad Solicitada (UMB)",
  soldQuantitySuggestedUMP: "Cantidad Solicitada (UMP)",
  deliveredQuantity: "Cantidad Atendida (UMB)",
  deliveredQuantityUMP: "Cantidad Atendida (UMP)",
  lostSale: "Venta Perdida (UMB)",
  lostSaleUMP: "Venta Perdida (UMP)",
};

export const LOST_SALE_REAL_EXPORT_ID = "lost-sale-real";

export const LOST_SALE_REAL_TITLE = "Venta Perdida Real";

export const LOCALIZED_REAL_PROPERTIES = {
  trip: "Viaje",
  numberOrder: "Pedido",
  invoiceDocument: "Factura",
  sellerToName: "Responsable",
  subRoute: "Ruta",
  salesOffice: "Oficina de Venta",
  user: "Usuario",
  date: "Fecha",
  loadDateTime: "Fecha de Carga",
  shipToExternalKeyCode: "Código Socio de Negocio",
  shipToName: "Socio de Negocio",
  materialName: "Material",
  soldUnitOfMeasure: "UMB",
  parallelUnitOfMeasure: "UMP",
  soldQuantitySuggested: "Cantidad Solicitada (UMB)",
  soldQuantitySuggestedUMP: "Cantidad Solicitada (UMP)",
  invoiceQuantity: "Cantidad Facturada (UMB)",
  invoiceQuantityUMP: "Cantidad Facturada (UMP)",
  lostSale: "Venta Perdida (UMB)",
  lostSaleUMP: "Venta Perdida (UMP)",
};
